export const SET_CURRENT_SENSOR_VALUE = 'SET_CURRENT_SENSOR_VALUE'

export const setCurrentSensorValue = (sensorValueId) => ({
  type: SET_CURRENT_SENSOR_VALUE,
  payload: sensorValueId,
})
